import styled from 'styled-components';

const AnswerVideoFrame = styled.div`
    padding: 2rem;
    background-color: ${p => p.theme.lightGray};

    & video {
        width: 100%;
    }
`;

export default AnswerVideoFrame;



// WEBPACK FOOTER //
// ./src/components/AnswerVideoFrame.tsx